import {
    enableProdMode,
    importProvidersFrom,
    inject,
    provideAppInitializer,
    provideZoneChangeDetection
} from '@angular/core';
import { routes } from './app/app-routing';
import { environment } from './environments/environment';
import { AuthService } from './app/auth/services/auth.service';
import { filter, Observable, tap } from 'rxjs';
import { TRACKING_CONFIG, TrackingSuiteModule } from '@siemens/tracking-suite-angular-lib';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { bootstrapApplication } from '@angular/platform-browser';
import { MatTableModule } from '@angular/material/table';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideInterceptors, provideMsalConfiguration, provideMsalServices } from './app/auth/providers';
import { initializeMsal } from './app/auth/utils';
import { MsalService } from '@azure/msal-angular';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        importProvidersFrom(
            MatTableModule,
            MatSnackBarModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: createTranslateLoader,
                    deps: [HttpClient]
                }
            }),
            TrackingSuiteModule,
            CommonModule,
            ToastrModule.forRoot({
                toastClass: 'sag-toast ngx-toastr',
                timeOut: 5000,
                closeButton: true,
                newestOnTop: true,
                maxOpened: 4,
                autoDismiss: true,
                preventDuplicates: false,
                easeTime: 300,
                easing: 'ease',
                tapToDismiss: true
            })
        ),
        provideMsalConfiguration({
            msalConfig: environment.msalConfig,
            apiConfig: environment.apiConfig
        }),
        provideMsalServices(),
        provideInterceptors(),

        provideAppInitializer(() => {
            const initializerFn = initializeMsal(inject(MsalService));
            return initializerFn();
        }),
        {
            provide: TRACKING_CONFIG,
            useValue: {
                apiKey: environment.newTracking.apiKey,
                apiVersion: 'v3', // optional, default = 'v3'
                endpointStage: environment.newTracking.endpointStage
            }
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideAnimations()
    ]
}).catch((err) => console.error(err));
